module.exports = __webpack_public_path__ + "img/CZ64948242.75834df8.png";